import React from 'react';
import { Link } from 'react-router-dom';
import { SITE_CONFIG, NAV_LINKS, FOOTER_CONTENT } from '../data';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-grid">
            {/* Brand */}
            <div className="footer-brand">
              <Link to="/" className="footer-logo">
                <div className="footer-logo-mark">
                  <svg width="32" height="32" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="40" height="40" rx="8" fill="url(#flogo-gradient)" />
                    <rect x="19" y="8" width="2" height="22" fill="white" rx="1"/>
                    <rect x="10" y="14" width="20" height="2" fill="white" rx="1"/>
                    <circle cx="11" cy="16" r="1.5" fill="white"/>
                    <path d="M8 22 Q11 19 14 22" stroke="white" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
                    <circle cx="29" cy="16" r="1.5" fill="white"/>
                    <path d="M26 20 Q29 17 32 20" stroke="white" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
                    <rect x="13" y="29" width="14" height="2" fill="white" rx="1"/>
                    <circle cx="20" cy="10" r="2" fill="#e8752a"/>
                    <defs>
                      <linearGradient id="flogo-gradient" x1="0" y1="0" x2="40" y2="40">
                        <stop offset="0%" stopColor="#c0392b"/>
                        <stop offset="100%" stopColor="#d35400"/>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <span className="footer-logo-text">{SITE_CONFIG.name}</span>
              </Link>
              <p className="footer-desc">{FOOTER_CONTENT.description}</p>
              <div className="footer-social">
                <a href={SITE_CONFIG.twitter} target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Twitter/X">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="17" height="17"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
                </a>
                <a href={SITE_CONFIG.instagram} target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="17" height="17"><rect x="2" y="2" width="20" height="20" rx="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
                </a>
                <a href={SITE_CONFIG.linkedin} target="_blank" rel="noopener noreferrer" className="social-link" aria-label="LinkedIn">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="17" height="17"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-4 0v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></svg>
                </a>
                <a href={SITE_CONFIG.youtube} target="_blank" rel="noopener noreferrer" className="social-link" aria-label="YouTube">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="17" height="17"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.41 19.1C5.12 19.56 12 19.56 12 19.56s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.95 29 29 0 0 0 .46-5.33 29 29 0 0 0-.46-5.33z"/><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" fill="#1c1c1e"/></svg>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-col">
              <h4 className="footer-col-title">{FOOTER_CONTENT.quickLinksTitle}</h4>
              <ul className="footer-links">
                {NAV_LINKS.map((link) => (
                  <li key={link.path}>
                    <Link to={link.path}>{link.label}</Link>
                  </li>
                ))}
                <li><Link to="/basvuru">Başvuru</Link></li>
              </ul>
            </div>

            {/* Contact */}
            <div className="footer-col">
              <h4 className="footer-col-title">{FOOTER_CONTENT.contactTitle}</h4>
              <ul className="footer-contact-list">
                <li>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="15" height="15"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                  <a href={`mailto:${SITE_CONFIG.email}`}>{SITE_CONFIG.email}</a>
                </li>
                <li>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="15" height="15"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.5a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2.7h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 10.1a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.28 17.5v-.58z"/></svg>
                  <span>{SITE_CONFIG.phone}</span>
                </li>
                <li>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="15" height="15"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                  <span>{SITE_CONFIG.location}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <p>© {new Date().getFullYear()} {FOOTER_CONTENT.copyright}</p>
          <div className="footer-bottom-links">
            <a href="#">{FOOTER_CONTENT.privacyLabel}</a>
            <a href="#">{FOOTER_CONTENT.termsLabel}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
